import { HomeHQAccess, HomeHQPlanOption } from '@/models/Subscription';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getHomeHQAccess = async (): Promise<HomeHQAccess> => {
  const url = '/billing/access';

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<HomeHQAccess>(url);

  return response.data;
};

export const getHomeHQPlans = async (): Promise<HomeHQPlanOption[]> => {
  const url = '/billing/plans';

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<{ plans: HomeHQPlanOption[] }>(url);

  return response.data.plans;
};

/** Starts Stripe Checkout; returns the hosted Checkout URL to redirect to. */
export const createHomeHQCheckout = async (data: {
  lookupKey: string;
  promoCode?: string;
}): Promise<string> => {
  const url = '/billing/checkout';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<{ url: string }>(url, data);

  return response.data.url;
};

/** Opens the Stripe billing portal (card, plan, cancel, invoices); returns its URL. */
export const createHomeHQPortalSession = async (): Promise<string> => {
  const url = '/billing/portal';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<{ url: string }>(url);

  return response.data.url;
};

/** Emails a code to the address a HomeHQ purchase was made with (outside the app). */
export const startHomeHQPurchaseClaim = async (email: string): Promise<void> => {
  const url = '/billing/claim/start';

  logger.debug(`POST ${url}`);
  await apiClient.post(url, { email });
};

/** Checks the emailed code and links the purchase; returns the updated access. */
export const verifyHomeHQPurchaseClaim = async (code: string): Promise<HomeHQAccess> => {
  const url = '/billing/claim/verify';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<HomeHQAccess>(url, { code });

  return response.data;
};

/** Public: who bought, from the Checkout session a Payment Link redirected back with. */
export const getHomeHQPurchase = async (
  sessionId: string,
): Promise<{ email: string; planName: string | null }> => {
  const url = `/billing/purchase/${encodeURIComponent(sessionId)}`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<{ email: string; planName: string | null }>(url);

  return response.data;
};
